import { isRequired } from 'forms/validators';
import React from 'react';

import { Grid } from 'semantic-ui-react';
import FieldValues from 'components/FieldValues';
import {
    SprayEventOperations,
    SprayEventPostRequestPayload
} from 'services/sprayEvents/types';
import EquipmentSetDropdown from 'components/EquipmentSetDropdown';
import get from 'lodash.get';
import Calibrations from '../Calibrations';
import { OperatorFieldNames } from '../../../MultipleOperatorsTab/constants';

interface Props {
    name?: string;
}

export default function OperatorsEquipmentSet(
    props: Props
): React.ReactElement {
    const { name = '' } = props;

    const getFieldName = (fieldName: string): string =>
        name.length > 0 ? `${name}.${fieldName}` : fieldName;

    const getExcludeEquipmentSetId = (
        sprayEventOperations: SprayEventOperations
    ) => {
        switch (name) {
            case OperatorFieldNames.OUTSIDE: {
                const doubleRowOperator = get(
                    sprayEventOperations,
                    1,
                    undefined
                );
                return (
                    doubleRowOperator && doubleRowOperator.sprayEquipmentSetId
                );
            }
            case OperatorFieldNames.DOUBLE: {
                const outsideRowOperator = get(
                    sprayEventOperations,
                    0,
                    undefined
                );
                return (
                    outsideRowOperator && outsideRowOperator.sprayEquipmentSetId
                );
            }
            default:
                return undefined;
        }
    };

    return (
        <FieldValues<SprayEventPostRequestPayload>
            fieldNames={[
                'sprayMethod',
                'entityId',
                'sprayApplicationRate',
                'sprayEventOperations'
            ]}
        >
            {({
                sprayMethod,
                entityId,
                sprayApplicationRate,
                sprayEventOperations
            }): React.ReactElement => {
                return (
                    <Grid>
                        <Grid.Row>
                            <Grid.Column width="16">
                                <EquipmentSetDropdown
                                    validate={isRequired}
                                    name={getFieldName('sprayEquipmentSetId')}
                                    nullOnUnmount={false}
                                    applicationRate={
                                        sprayApplicationRate as number
                                    }
                                    sprayMethod={sprayMethod as string}
                                    entityId={entityId as number}
                                    excludeEquipmentSetId={getExcludeEquipmentSetId(
                                        sprayEventOperations as SprayEventOperations
                                    )}
                                />
                            </Grid.Column>
                        </Grid.Row>
                        <Grid.Row>
                            <Grid.Column width="16">
                                <Calibrations name={name} />
                            </Grid.Column>
                        </Grid.Row>
                    </Grid>
                );
            }}
        </FieldValues>
    );
}

OperatorsEquipmentSet.defaultProps = {
    name: OperatorFieldNames.STANDARD
};
